import { Navigate, useParams } from 'react-router-dom';
import { PATH_CONSTANT } from 'constant/PathConstant';
import { TableDefinitionEditorForm } from './components/TableDefinitionEditorForm';
import { isTableDefinitionKind } from './utils/tableDefinitionRoutes';

export default function CreateTableDefinitionPage() {
  const { subjectId, definitionKind } = useParams<{ subjectId: string; definitionKind: string }>();
  if (!subjectId || !isTableDefinitionKind(definitionKind)) {
    return <Navigate to={PATH_CONSTANT.SYSTEM.KMS.DATA_BUILDER.TABLE_DEFINITION_V2.LIST} replace />;
  }
  return <TableDefinitionEditorForm mode='create' subjectId={subjectId} definitionKind={definitionKind} />;
}

